const isProduction = process.env.NODE_ENV === 'production'

import { gsap, DrawSVGPlugin, ScrollToPlugin, ScrollTrigger } from 'gsap/all'
import { accordion, brandBanner, formElement, authForm } from './components'
import { cart, filter, increment, search, userControl } from 'ekom'
import { checkoutPage, formPage, productPage } from './pages'
import { brandsSlider, header, hero } from './sections'
import { a11y, lazyLoad, overlayGrid, pageTransitions, theme, recaptcha } from './utility'

/** Root APP Interface*/
export interface IAPP {
  /** @descripton Init function
   * @returns void
   */

  init: () => void
}

const app: IAPP = {
  init(): void {
    gsap.registerPlugin(DrawSVGPlugin, ScrollToPlugin, ScrollTrigger)

    // pages
    document.querySelectorAll('.checkout-page').forEach((target) => checkoutPage(target))
    document.querySelectorAll('.form-page').forEach((target) => formPage(target))
    document.querySelectorAll('.product-page').forEach((target) => productPage(target))

    // sections
    header.init()
    document.querySelectorAll('.brands-slider').forEach((target) => brandsSlider(target))
    document.querySelectorAll('.hero').forEach((target) => hero(target))

    // components
    accordion.init()
    document.querySelectorAll('.brand-banner, .featured-banner').forEach((target) => brandBanner(target))
    document.querySelectorAll('.form-element').forEach((target) => formElement(target))
    authForm.init()
    // ekom

    userControl.init()
    document.querySelectorAll('.filter').forEach((target) => filter(target))
    document.querySelectorAll('.increment').forEach((target) => increment(target))
    document.querySelectorAll('.search').forEach((target) => search(target))
    cart.init()
    // utility
    a11y.init()
    pageTransitions.init() // TODO - page transitions - maybe enable later, for phase 2
    lazyLoad.init() // has to be last so it doesn't mess around with images in swipers
    theme.init()
    recaptcha.init()
    !isProduction && overlayGrid.init()
  },
}

app.init()
